import { Component, Input } from '@angular/core';
import {
  AssignToUserService,
  AssignUserPersistenceIJ
} from 'src/app/shared/general/assigned-to/assign-to-user.service';
import { AssignToServiceIJ } from 'src/app/shared/general/assigned-to/assigned-to.component';
import { WorkshopJobService } from 'src/app/shared/services/workshop-job.service';
import { AssignJobOwnerPersistenceService } from './assign-job-owner-persistence.service';
import { ViewWorkshopJobStoreService } from '../view-workshop-job-store.service';
import { map } from 'rxjs';
import { WorkshopJob } from 'src/app/models/workshop-job';
import { SiteVisitComponent } from './site-visit/site-visit.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { AssignedToComponent } from '../../../shared/general/assigned-to/assigned-to.component';

@Component({
    selector: 'app-job-settings',
    templateUrl: './job-settings.component.html',
    providers: [
        {
            provide: AssignToServiceIJ,
            useClass: AssignToUserService
        },
        {
            provide: AssignUserPersistenceIJ,
            useClass: AssignJobOwnerPersistenceService
        }
    ],
    standalone: true,
    imports: [AssignedToComponent, ReactiveFormsModule, FormsModule, SiteVisitComponent]
})
export class JobSettingsComponent {
  @Input() job: WorkshopJob<any>;

  constructor(private store: ViewWorkshopJobStoreService) {}
}
